// Identificação de tipos de tarefa por nome, tolerante à capitalização/espaços
// que o backend possa usar (ex.: "Agendamento de assinatura").
const normalizar = (texto: string | null | undefined): string =>
  (texto ?? "").trim().replace(/\s+/g, " ").toLowerCase();

export const isAgendamentoVisita = (
  nomeTipoTarefa: string | null | undefined
): boolean => normalizar(nomeTipoTarefa) === "agendamento de visita";

export const isAgendamentoAssinatura = (
  nomeTipoTarefa: string | null | undefined
): boolean => normalizar(nomeTipoTarefa) === "agendamento de assinatura";
